"use client"

const BackToTop = () => (
  <button
    type="button"
    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    className="w-full bg-amz-navy-hover hover:bg-[#485769] text-white text-sm py-4"
  >
    Volver arriba
  </button>
)

export default BackToTop
